module.exports = __webpack_public_path__ + "img/img1.a20db35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img1.png
// module id = 249
// module chunks = 0